import { render, staticRenderFns } from "./ReviewPrev.vue?vue&type=template&id=0f12b01b&scoped=true&"
import script from "./ReviewPrev.vue?vue&type=script&lang=js&"
export * from "./ReviewPrev.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPrev.vue?vue&type=style&index=0&id=0f12b01b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f12b01b",
  null
  
)

export default component.exports